import { FulfillmentOption } from '@admin-shared/models/fulfillment-option';
import { ApiBase } from './api.base';
import { StorageParameters } from '../storage.service';
import { Observable } from 'rxjs';

export class FoundationFulfillmentOptionApi extends ApiBase {
  model = 'foundations';

  public getFulfillmentOptions(foundationId: string): Observable<FulfillmentOption[]> {
    return this.http.get<FulfillmentOption[]>(this.buildUrl(foundationId, 'fulfillment-option'), {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  public createFulfillmentOption(foundationId: string, data: FulfillmentOption): Observable<FulfillmentOption> {
    return this.http.post<FulfillmentOption>(this.buildUrl(foundationId, 'fulfillment-option'), data, {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  public patchFulfillmentOption(data: FulfillmentOption): Observable<FulfillmentOption> {
    return this.http.patch<FulfillmentOption>(this.buildUrl(data.foundationId!, 'fulfillment-option'), data, {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  public orderFulfillmentOption(foundationId: string, data: {id: string, sequence: number}[]) {
    return this.http.post<{id: string, sequence: number}[]>(this.buildUrl(foundationId, 'fulfillment-option', 'order'), data, {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }
}
